import { atom } from "jotai";

export const enableAdsReporting = atom<boolean>(true);
